
import React from 'react';
import NumberInput from '../commons/NumberInput.jsx'
import Select from '../commons/Select.jsx'
import Helper from "../../../model/Helper";
import SidebarFrame from "./SidebarFrame";

export default class ElementSettings extends SidebarFrame {


    constructor(props) {
        super(props)
        const arrangement = APP.arrangement;
        const schrank = arrangement.schraenke[arrangement.currentSchrankIndex]
        let index = schrank.elements.indexOf(props.model)
        if (index==-1) index = 0
        this.state = {
            element: index
        }
        APP.model.selectElement(index)
    }

    getSidebarParent() {
        return "korpus";
    }

    renderTitle() {
        return I18N("Elemente");
    }

    cm(value) {
        return Helper.formatNum(value);
    }

    selectElement(element) {
        this.setState({element:element})
        APP.model.selectElement(element)
    }

    disableHoehe() {
        return APP.arrangement.Modell.Name!='Standard';
    }

    renderBody() {

        const arrangement = APP.arrangement;
        const schrank = arrangement.schraenke[arrangement.currentSchrankIndex]
        this.state.element = Maths.cutBetween(0,this.state.element,schrank.elements.length-1);
        const element = schrank.elements[this.state.element];
        const select = [];
        for (let i=1; i<=schrank.elements.length; i++) {
            select.push({value:i-1, label:i});
        }

        return (
            <div>
                <Select value={this.state.element} options={select} onChange={value=>this.selectElement(parseInt(value))} label={I18N("Element")}/>
                <NumberInput value={element.size.x} onBlur={value=>APP.model.setBreite(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)} label={I18N("Breite")} unit={"cm"}/>
                <NumberInput value={element.getOuterHeight()} onBlur={value=>APP.model.setHoehe(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)} label={I18N("Höhe")} unit={"cm"} disabled={this.disableHoehe()}/>
                <NumberInput value={element.size.z} onBlur={value=>APP.model.setTiefe(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)} label={I18N("Nutztiefe")} unit={"cm"} disabled={true}/>
            </div>
        )
    }
}